import axiosPrivate from "../../../../api/axiosPrivate";
import {
  CREATE_CUSTOMER_SAVINGS_POLICY,
  CREATE_SAVINGS_POLICY_CONFIG,
  EDIT_SINGLE_SAVINGS_APPLIED_POLICY,
  FILTER_SAVINGS_POLICIES,
  GET_ACTIVE_SAVINGS_POLICIES,
  GET_APPLIED_SAVINGS_POLICIES,
  GET_SAVINGS_POLICY,
  GET_SAVINGS_POLICY_CONFIG,
  GET_SAVINGS_POLICY_COVER,
  GET_SINGLE_APPLIED_SAVINGS_POLICIES,
  GET_SINGLE_SAVINGS_POLICY,
  UPDATE_SAVINGS_POLICY,
} from "../../../../api/constant";

const createSavingsPolicyConfig = async (data) => {
  const response = await axiosPrivate.post(CREATE_SAVINGS_POLICY_CONFIG, data);
  return response.data;
};

const getSavingsPolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_SAVINGS_POLICY}?page=${data?.pageNumber}&office_id=${data?.office_id}`
  );
  return response.data;
};

const getSingleSavingsPolicy = async (payload) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_SAVINGS_POLICY}/${payload.id}?office_id=${payload.office_id}`
  );
  return response.data;
};

const updateSavingsPolicy = async ({ id, payload }) => {
  const response = await axiosPrivate.post(
    `${UPDATE_SAVINGS_POLICY}/${id}`,
    payload
  );
  return response.data;
};

const getSavingsPolicyCover = async ({ policy_id }) => {
  const response = await axiosPrivate.get(
    `${GET_SAVINGS_POLICY_COVER}?policy_savings_id=${policy_id}`
  );
  return response.data;
};

const getAllActiveSavingsPolicies = async ({ office_id }) => {
  const response = await axiosPrivate.get(
    `${GET_ACTIVE_SAVINGS_POLICIES}?office_id=${office_id}`
  );
  return response.data;
};

const getSavingsPolicyConfig = async ({ policy_id }) => {
  const response = await axiosPrivate.get(
    `${GET_SAVINGS_POLICY_CONFIG}?policy_id=${policy_id}`
  );
  return response.data;
};

const createCustomerSavingsPolicy = async (payload) => {
  const response = await axiosPrivate.post(
    `${CREATE_CUSTOMER_SAVINGS_POLICY}`,
    payload
  );
  return response.data;
};

const getAppliedSavingsPolicies = async ({ pageNumber, office_id, search }) => {
  const response = await axiosPrivate.get(
    `${GET_APPLIED_SAVINGS_POLICIES}?page=${pageNumber}&office_id=${office_id}&search=${search}`
  );
  return response.data;
};

// const getSingleSavingsPolicyCover = async (data) => {
//   const response = await axiosPrivate.get(
//     `${GET_SINGLE_APPLIED_SAVINGS_POLICIES}?customer_id=${data?.customer_id}&policy_app_number=${data?.policy_number}`
//   );
//   return response.data;
// };

const getSingleAppliedSavingsPolicy = async (data) => {
  const response = await axiosPrivate.get(
    `${GET_SINGLE_APPLIED_SAVINGS_POLICIES}?customer_id=${data?.customer_id}&policy_app_number=${data?.policy_number}&page=${data?.pageNumber}`
  );
  return response.data;
};

const filteredSavingsPolicies = async (data) => {
  const response = await axiosPrivate.get(
    `${FILTER_SAVINGS_POLICIES}?page=${data?.pageNumber}&office_id=${data?.office_id}&staff_id=${data?.staff_id}`
  );
  return response.data;
};

const editSingleSavingsAppliedPolicy = async (data) => {
  const response = await axiosPrivate.post(
    `${EDIT_SINGLE_SAVINGS_APPLIED_POLICY}`,
    data
  );
  return response.data;
};

const savingsPolicyService = {
  createSavingsPolicyConfig,
  getSavingsPolicies,
  getSingleSavingsPolicy,
  updateSavingsPolicy,
  getSavingsPolicyCover,
  getSavingsPolicyConfig,
  createCustomerSavingsPolicy,
  getAllActiveSavingsPolicies,
  getAppliedSavingsPolicies,
  // getSingleSavingsPolicyCover,
  getSingleAppliedSavingsPolicy,
  filteredSavingsPolicies,
  editSingleSavingsAppliedPolicy,
};

export default savingsPolicyService;
